/* eslint-disable no-nested-ternary */
import IconPlus from '@assets/icons/plus.svg?react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import InfoDocuments from '../../common/InfoSidebar/InfoDocuments';
import { titleStyles } from '../../common/InfoSidebar/infoStyles';
import InfoDataList from './InfoDataList';

/* eslint-disable @typescript-eslint/no-explicit-any */
interface InfoAdditionalProps {
 data: any;
}

const InfoAdditional = ({ data }: InfoAdditionalProps) => {
 const { t } = useTranslation();
 const th = useTheme();
 //  useEffect(() => {
 //   console.log(structure);
 //  }, [structure]);

 return !data ? (
  <>loading</>
 ) : (
  <Box>
   <InfoDocuments id={data.Id} table="results" />
   <Typography sx={titleStyles}>
    Nuorodos <IconPlus style={{ color: th.palette.kemek.darkestGray }} />
   </Typography>
   <Box
    sx={{
     textAlign: 'center',
     p: '12px',
     backgroundColor: th.palette.kemek.lightBlue,
     mb: 3,
    }}
   >
    <Typography variant="body2" color="text.secondary">
     {t('global.noItemsFound')}
    </Typography>
   </Box>

   <InfoDataList data={data} />
  </Box>
 );
};
export default InfoAdditional;
